import React, { useEffect, useState } from 'react'
import Layout from '../../../components/common/pageLayout'
import Form from '../../../components/Production/Form/NewBuildingNCR/index'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import constant from '../../../constant';
import { toast } from 'react-toastify';
import {
    v2_projects,
    v2_ships,
} from '../../../actions/v2/projectAndVessel';
import {
    v3_fetchNewBuildingNCRFields,
    v3_submitNewBuildingNCR,

} from '../../../actions/v3/productionForm';
import { NumberFormatBase } from 'react-number-format';
import Swal from 'sweetalert2';
import { v2_yards } from '../../../actions/v2/masterData';
import { v2_user_by_roles } from '../../../actions/v2/user';
import { getSessionStorage, getStorage } from '../../../utils';

const NewBuildingBlockInspectionStatus = (props) => {
    const [ud, set_ud] = useState(JSON.parse(atob(getSessionStorage(constant.keys.userDetails))));

    const location = useLocation();
    const { data } = location.state || {};

    const [state, setState] = useState({
        contract_clause: { name: 'contract_clause', value: '', error: '', isRequired: true },
        specification_reference: { name: 'specification_reference', value: '', error: '', isRequired: true },
        drawing_number: { name: 'drawing_number', value: '', error: '', isRequired: true },
        classification_standard_reference: { name: 'classification_standard_reference', value: '', error: '', isRequired: true },
        wps_refenrece: { name: 'wps_refenrece', value: '', error: '', isRequired: true },
        material_change: { name: 'material_change', value: '', error: '', isRequired: true },
        equipment_list: { name: 'equipment_list', value: '', error: '', isRequired: true },
        site_query_refence: { name: 'site_query_refence', value: '', error: '', isRequired: true },
        inspection_comment_reference: { name: 'inspection_comment_reference', value: '', error: '', isRequired: true },
        approval_comment_reference: { name: 'approval_comment_reference', value: '', error: '', isRequired: true },
        building_standard_reference: { name: 'building_standard_reference', value: '', error: '', isRequired: true },
        meeting_minute_refenrece: { name: 'meeting_minute_refenrece', value: '', error: '', isRequired: true },
        safety_issue: { name: 'safety_issue', value: '', error: '', isRequired: true },
        other: { name: 'other', value: '', error: '', isRequired: true },
        location: { name: 'location', value: '', error: '', isRequired: true },
        work_to_be_stopped_for_corrective_measure: { name: 'work_to_be_stopped_for_corrective_measure', value: '', error: '', isRequired: true },
        description: { name: 'description', value: '', error: '', isRequired: true },
        verified_by_site_team: { name: 'verified_by_site_team', value: '', error: '', isRequired: false },
        ship_yard_reply: { name: 'ship_yard_reply', value: '', error: '', isRequired: false },
        ship_yard_signature: { name: 'ship_yard_signature', value: '', error: '', isRequired: false },
        site_team_signature: { name: 'site_team_signature', value: '', error: '', isRequired: false },
        site_team_signature_date: { name: 'site_team_signature_date', value: '', error: '', isRequired: false },
    });
    const handleChange = (e) => {
        const { name, value } = e.target;

        setState(prevState => ({
            ...prevState,
            [name]: {
                ...prevState[name],
                value,
                error: '', // Optionally clear error on change
            },
        }));
    };



    const [commonDetails, setCommonDetails] = useState({
        ship: { value: '', options: [], error: '' },
        date: { value: '', error: '' },
        finalSubmit: { value: false },
        owner: { value: '' },
        yard: { value: '', options: [], },
        sentTo: { value: '', options: [] },
        replyByDate: { value: '' },
        issuedBy: { value: '' },
        reference_number: { value: '' },
        subject: { value: '' }
    });

    const [showLoader, setShowLoader] = useState(false);

    // Load projects
    useEffect(() => {
        v2_user_by_roles().then((res) => {
            if (res.status) {
                setCommonDetails((prev) => ({
                    ...prev,
                    sentTo: { ...prev.sentTo, options: res.result },
                }));
            }
        });
        v2_yards().then((res) => {
            if (res.status) {
                setCommonDetails((prev) => ({
                    ...prev,
                    yard: { ...prev.yard, options: res.result },
                }));
            }
        })
    }, []);

    // Load ships when project changes
    useEffect(() => {
        if (commonDetails.yard.value) {
            v2_ships(null, null, commonDetails.yard.value).then((res) => {
                if (res.status) {
                    setCommonDetails((prev) => ({
                        ...prev,
                        ship: { ...prev.ship, options: res.result },
                    }));
                }
            });
        } else {
            setCommonDetails((prev) => ({
                ...prev,
                ship: { value: '', options: [] },
            }));
        }
    }, [commonDetails.yard.value]);

    useEffect(() => {
        const params = data ? JSON.parse(atob(data)) : null;

        if (params) {
            setShowLoader(true);

            v3_fetchNewBuildingNCRFields(params.FORM_ID)
                .then((res) => {
                    if (res.status) {
                        const { records } = res.result;
                        
                        // Set common details
                        if (params.FORM_ID) {
                            setCommonDetails((prev) => ({
                                ...prev,
                                yard: { ...prev.yard, value: res.result.commonDetails?.YARD_ID || '' },
                                ship: { ...prev.ship, value: res.result.commonDetails?.SHIP_ID || '' },
                                date: { ...prev.date, value: res.result.commonDetails?.SUBMISSION_DATE || '' },
                                finalSubmit: { ...prev.finalSubmit, value: Boolean(res.result.commonDetails?.FINAL_SUBMITTED) },
                                sentTo: { ...prev.sentTo, value: res.result.commonDetails?.SENT_TO || '' },
                                replyByDate: { ...prev.replyByDate, value: res.result.commonDetails?.REPLY_BY || '' },
                                issuedBy: { ...prev.issuedBy, value: res.result.commonDetails?.ISSUED_BY_NAME || '' },
                                reference_number: { ...prev.reference_number, value: res.result.commonDetails?.REFERENCE_NUMBER || '' },
                                subject: { ...prev.subject, value: res.result.commonDetails?.SUBJECT || '' },
                            }));

                            // Set state fields
                            
                            setState((prev) => ({
                                ...prev,
                                contract_clause: { ...prev.contract_clause, value: records?.CONTRACT_CLAUSE || '' },
                                specification_reference: { ...prev.specification_reference, value: records?.SPECIFICATION_REFERENCE || '' },
                                drawing_number: { ...prev.drawing_number, value: records?.DRAWING_NUMBER || '' },
                                classification_standard_reference: { ...prev.classification_standard_reference, value: records?.CLASSIFICATION_STANDARDS_REFERENCE || '' },
                                wps_refenrece: { ...prev.wps_refenrece, value: records?.WPS_REFERENCE || '' },
                                material_change: { ...prev.material_change, value: records?.MATERIAL_CHANGE || '' },
                                equipment_list: { ...prev.equipment_list, value: records?.EQUIPMENT_LIST || '' },
                                site_query_refence: { ...prev.site_query_refence, value: records?.SITE_QUERY_REFERENCE || '' },
                                inspection_comment_reference: { ...prev.inspection_comment_reference, value: records?.INSPECTION_COMMENT_REFERENCE || '' },
                                approval_comment_reference: { ...prev.approval_comment_reference, value: records?.APPROVAL_COMMENT_REFERENCE || '' },
                                building_standard_reference: { ...prev.building_standard_reference, value: records?.BUILDING_STANDARDS_REFERENCE || '' },
                                meeting_minute_refenrece: { ...prev.meeting_minute_refenrece, value: records?.MEETING_MINUTES_REFERENCE || '' },
                                safety_issue: { ...prev.safety_issue, value: records?.SAFETY_ISSUES || '' },
                                other: { ...prev.other, value: records?.OTHER || '' },
                                location: { ...prev.location, value: records?.LOCATION || '' },
                                work_to_be_stopped_for_corrective_measure: {
                                    ...prev.work_to_be_stopped_for_corrective_measure,
                                    value: records?.WORK_TO_STOPPED_FOR_CORRECTIVE_MEASURE || ''
                                },
                                description: { ...prev.description, value: records?.DESCRIPTION || '' },
                                verified_by_site_team: { ...prev.verified_by_site_team, value: records?.VERIFIED_BY_SITE_TEAM || '' },
                                ship_yard_reply: { ...prev.ship_yard_reply, value: records?.SHIP_YARD_REPLY || '' },
                                ship_yard_signature: { ...prev.ship_yard_signature, value: records?.SHIP_YARD_SIGNATURE || '' },
                                site_team_signature: { ...prev.site_team_signature, value: records?.SITE_TEAM_SIGNATURE || '' },
                                site_team_signature_date: { ...prev.site_team_signature_date, value: records?.SITE_TEAM_SIGNATURE_DATE || '' },
                            }));
                        }

                    } else {
                        toast.error(res.error || 'Error fetching NCR form data');
                    }
                })
                .catch(() => {
                    toast.error('Something went wrong while fetching.');
                })
                .finally(() => {
                    setShowLoader(false);
                });
        }
    }, []);


    const onSubmit = async () => {
        // 1. Validation
        const errors = [];
        if (!commonDetails.yard.value) errors.push('Select a yard.');
        if (!commonDetails.ship.value) errors.push('Select a ship.');
        if (!commonDetails.yard.value) errors.push('Select a ship.');
        if (!commonDetails.reference_number.value) errors.push('Select a ship.');
        if (!commonDetails.replyByDate.value) errors.push('Select a ship.');
        if (!commonDetails.date.value) errors.push('Select a ship.');
        if (!commonDetails.subject.value) errors.push('Select a ship.');
        if (!commonDetails.replyByDate.value) errors.push('Select a ship.');

        // Validate each row
        if (commonDetails.finalSubmit.value) {
            Object.entries(state).forEach(([key, field]) => {

                const isRequired = field.isRequired; // Enforce all fields if finalSubmit is true
                if (isRequired && !field.value) {
                    errors.push(`${key.replace(/_/g, ' ')} is required.`);
                }
            });
        }


        if (errors.length > 0) {
            toast.error(errors.join('\n'));
            return;
        }
        // If final submit is true, confirm before proceeding
        if (commonDetails.finalSubmit.value) {
            const confirmResult = await Swal.fire({
                title: 'Are you sure?',
                text: 'Do you want to submit the reports for Office Review?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it',
                cancelButtonText: 'Cancel',
            });
            if (!confirmResult.isConfirmed) return;
        }


        const formattedRow = {};
        Object.keys(state).forEach((key) => {
            formattedRow[key] = state[key].value;
        });
        if (state['entryId']) {
            formattedRow.ID = state['entryId']
        }

        // 3. Build full payload
        const payload = {
            commonDetails: {
                yard: commonDetails.yard.value,
                ship: commonDetails.ship.value,
                date: commonDetails.date.value,
                finalSubmit: commonDetails.finalSubmit.value,
                owner: commonDetails.owner.value,
                replyByDate: commonDetails.replyByDate.value,
                sentTo: commonDetails.sentTo.value,
                issuedBy: commonDetails.issuedBy.value,
                reference_number: commonDetails.reference_number.value,
                subject: commonDetails.subject.value,
            },
            checklistItems: formattedRow,
        };

        
        // 4. Submit
        setShowLoader(true);
        v3_submitNewBuildingNCR(payload)
            .then((res) => {
                setShowLoader(false);
                if (res.status) {
                    toast.success(res.result.message || 'Submitted successfully!');
                    props.history.push(constant.Authedcomponent.submittedNewBuildingNCR.url);
                } else {
                    toast.error(res.error || 'Submission failed.');
                }
            })
            .catch((err) => {
                setShowLoader(false);
                toast.error('Submission failed.');
                console.error('Submit Error:', err);
            });
    };
    useEffect(() => {
        const selected = commonDetails.ship.options.find(
            (i) => i.ID == commonDetails.ship.value
        );

        if (selected) {
            setCommonDetails((prev) => ({
                ...prev,
                owner: {
                    ...prev.owner,
                    value: selected.OWNER_NAME || ''
                },
            }));
        }
        else {
            setCommonDetails((prev) => ({
                ...prev,
                owner: {
                    ...prev.owner,
                    value: ''
                },
            }));
        }
    }, [commonDetails.ship.value, commonDetails.ship.options]);


    return (
        <Layout title="Non Conformity Report">
            <div className="row">
                <div className="col-lg-12">
                    <div className="card" id={1}>
                        <div className="card-body">
                            <div className="checklist-title-bx">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="text-center">
                                            <h4>NON CONFORMITY REPORT
                                            </h4>
                                            <p>
                                                Following to be checked and confirmed before official delivery
                                                of the vessel
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 ">
                                    <div className="report-index-top">
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td className="hd-s2">
                                                        <p>Yard</p>
                                                    </td>
                                                    <td className="td-input-bx">
                                                        <div className="hull-select-box">
                                                            <select
                                                                className="form-select"
                                                                value={commonDetails.yard.value}
                                                                disabled={data ? true : false}
                                                                onChange={(e) =>
                                                                    setCommonDetails((prev) => ({
                                                                        ...prev,
                                                                        yard: { ...prev.yard, value: e.target.value },
                                                                    }))
                                                                }
                                                            >

                                                                <option value={''}>Select Yard</option>
                                                                {commonDetails.yard.options.map((item) => {
                                                                    return (<option value={item.ID}>{item.YARD_NAME}</option>)
                                                                })}
                                                            </select>
                                                        </div>
                                                    </td>
                                                    <td className="hd-s2 pl10">
                                                        <p>Hull No</p>
                                                    </td>
                                                    <td className="td-input-bx">
                                                        <div className="hull-select-box">
                                                            <select
                                                                className="form-select"
                                                                disabled={data ? true : false}
                                                                value={commonDetails.ship.value}
                                                                onChange={(e) => {
                                                                    setCommonDetails((prev) => ({
                                                                        ...prev,
                                                                        ship: { ...prev.ship, value: e.target.value }
                                                                    }));
                                                                }}


                                                            >

                                                                <option value={''}>Select Hull</option>
                                                                {commonDetails.ship.options.map((item) => {
                                                                    return (<option value={item.ID}>{item.HULL_NUMBER} - {item.SHIP_NAME}</option>)
                                                                })}
                                                            </select>
                                                        </div>
                                                    </td>
                                                    <td className="hd-s2 pl10">
                                                        <p>Owner</p>
                                                    </td>
                                                    <td className="td-input-bx">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={commonDetails.owner.value}
                                                            placeholder='Autofill'
                                                            disabled
                                                        />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="hd-s2">
                                                        <p>Date</p>
                                                    </td>
                                                    <td className="td-input-bx">
                                                        <input
                                                            type="date"
                                                            className="form-control"
                                                            value={commonDetails.date.value}
                                                            onChange={(e) =>
                                                                setCommonDetails((prev) => ({
                                                                    ...prev,
                                                                    date: { ...prev.date, value: e.target.value },
                                                                }))
                                                            }
                                                        />
                                                    </td>
                                                    <td className="hd-s2 pl10 w150">
                                                        <p>Sent To</p>
                                                    </td>
                                                    <td className="td-input-bx">
                                                        <select
                                                            className="form-select"
                                                            disabled={data ? true : false}
                                                            value={commonDetails.sentTo.value}
                                                            onChange={(e) => {
                                                                setCommonDetails((prev) => ({
                                                                    ...prev,
                                                                    sentTo: { ...prev.sentTo, value: e.target.value }
                                                                }));
                                                            }}


                                                        >

                                                            <option value={''}>Sent To</option>
                                                            {commonDetails.sentTo.options.map((item) => {
                                                                return (<option value={item.USER_ID}>{item.FULL_NAME}</option>)
                                                            })}
                                                        </select>
                                                    </td>
                                                    <td className="hd-s2 pl10">
                                                        <p>Please reply by</p>
                                                    </td>
                                                    <td className="td-input-bx">
                                                        <input
                                                            type="date"
                                                            className="form-control"
                                                            placeholder="(Mention a date within 5 days of issuing NCR)"

                                                            value={commonDetails.replyByDate.value}
                                                            onChange={(e) =>
                                                                setCommonDetails((prev) => ({
                                                                    ...prev,
                                                                    replyByDate: { ...prev.replyByDate, value: e.target.value },
                                                                }))
                                                            }
                                                        />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="hd-s2">
                                                        <p>Issued By </p>
                                                    </td>
                                                    <td className="td-input-bx">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="(Designation and Name)"
                                                            defaultValue={commonDetails.issuedBy.value || ud.fullName}
                                                        />
                                                    </td>
                                                    <td className="hd-s2 pl10">
                                                        <p>Company reference No</p>
                                                    </td>
                                                    <td className="td-input-bx">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="(NCR/ Hull No/ NNNN)"
                                                            value={commonDetails.reference_number.value}
                                                            name={commonDetails.reference_number.name}
                                                            onChange={(e) =>
                                                                setCommonDetails((prev) => ({
                                                                    ...prev,
                                                                    reference_number: { ...prev.reference_number, value: e.target.value },
                                                                }))
                                                            }
                                                        />
                                                    </td>
                                                    <td className="hd-s2 pl10">
                                                        <p>Subject</p>
                                                    </td>
                                                    <td className="td-input-bx">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="(Give brief description)"
                                                            value={commonDetails.subject.value}
                                                            name={commonDetails.subject.name}

                                                            onChange={(e) =>
                                                                setCommonDetails((prev) => ({
                                                                    ...prev,
                                                                    subject: { ...prev.subject, value: e.target.value },
                                                                }))
                                                            }
                                                        />
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="note-info">
                                        <p>Enter date of issue/ Reference No/ Suject as above in NCR Index</p>
                                    </div>
                                </div>
                            </div>

                            <Form
                                onChange={handleChange}
                                state={state}
                                onSubmit={onSubmit}

                                isFinalSubmitting={commonDetails.finalSubmit.value}
                                setIsFinalSubmitting={() => setCommonDetails((prev) => ({
                                    ...prev,
                                    finalSubmit: { ...prev.finalSubmit, value: !commonDetails.finalSubmit.value },
                                }))}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default NewBuildingBlockInspectionStatus